import { srSpeak } from "./srSpeak";

otto.ally.assignNamespace(
  {
    srSpeak,
  },
  { lock: import.meta.env.VITE_OTTO_IS_TESTING_BUNDLE !== "true" },
);
